import axios from 'axios'
import { CSRF_HEADERS } from 'globals/constants'
import { API_SEARCH_URL, DEFAULT_ERROR } from './constants'

function buildSearchResults(results, state) {
  return {
    results,
    state,
  }
}

function handleSearchAPI(searchTerm, cancelToken) {
  const params = {
    params: {
      address: searchTerm,
    },
  }
  const options = {
    headers: { ...CSRF_HEADERS },
    cancelToken,
  }

  return axios
    .get(API_SEARCH_URL, params, options)
    .catch(() => Promise.reject(DEFAULT_ERROR))
    .then((response) => {
      if (response.status === 200 && response.data.success) {
        return Promise.resolve(buildSearchResults(response.data.results, response.data.state))
      } else if (response.data.message) {
        return Promise.reject(response.data.message)
      } else if (response.data.errors && response.data.errors.qasearch) {
        return Promise.reject(response.data.errors.qasearch[0])
      }
      return Promise.reject(DEFAULT_ERROR)
    })
}

export function searchForAddress(searchTerm, cancelToken) {
  if (searchTerm) {
    return handleSearchAPI(searchTerm, cancelToken)
  }
  return Promise.resolve(buildSearchResults([]))
}

export function parseAddress(address) {
  if (address) {
    return address.replace(/Unit ([0-9]{1,3})\s\s/i, 'Unit $1/')
  }
  return address
}



// WEBPACK FOOTER //
// ./components/AutocompleteAddress/actions.js